import React from 'react';
import styled, { css } from 'styled-components';

import device from '../utils/device';

const ButtonStyling = css`
  border: 3px solid
    ${({ $color, theme }) => $color || theme.colors.actionSecondary};
  color: ${({ $color, theme }) => $color || theme.colors.actionSecondary};
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;

  border-radius: 10rem;
  width: ${({ $fluid }) => ($fluid ? '100%' : 'auto')};
  display: block;
  text-align: center;

  font-size: ${({ $size }) => {
    switch ($size) {
      case 'SM':
        return '1rem';
      default:
      case 'MD':
        return '1.25rem';
      case 'LG':
        return '1.5rem';
    }
  }};
  padding: ${({ $size }) => {
    switch ($size) {
      case 'SM':
        return '0.5rem 1.5rem';
      default:
      case 'MD':
        return '1rem 3rem';
      case 'LG':
        return '2rem 4rem';
    }
  }};

  ${({ $variant }) =>
    $variant === 'solid' &&
    css`
      background: ${({ $color, theme }) =>
        $color || theme.colors.actionSecondary};
      color: #fff;
    `}

  @media ${device.desktop} {
    font-size: ${({ $size }) => {
      switch ($size) {
        case 'SM':
          return '1.25rem';
        default:
        case 'MD':
          return '1.5rem';
        case 'LG':
          return '1.75rem';
      }
    }};
    padding: ${({ $size }) => {
      switch ($size) {
        case 'SM':
          return '1rem 3rem';
        default:
        case 'MD':
          return '1.8rem 4.2rem';
        case 'LG':
          return '2.8rem 6.4rem';
      }
    }};
  }

  &:hover {
    text-decoration: underline;
  }
`;

const AnchorButton = styled.a`
  ${ButtonStyling}
`;
const ButtonButton = styled.button`
  ${ButtonStyling}
`;

const Button = ({
  className,
  to,
  onClick,
  variant,
  children,
  fluid,
  color,
  size,
  ...otherProps
}) => {
  if (to)
    return (
      <AnchorButton
        className={className}
        href={to}
        $variant={variant}
        $color={color}
        $fluid={fluid}
        $size={size}
        {...otherProps}
      >
        {children}
      </AnchorButton>
    );

  return (
    <ButtonButton
      className={className}
      onClick={onClick}
      $color={color}
      $variant={variant}
      $fluid={fluid}
      $size={size}
      {...otherProps}
    >
      {children}
    </ButtonButton>
  );
};

export { Button };
export default Button;
